import React, {useEffect} from 'react'
import {motion, useAnimation} from 'framer-motion'
import Image from 'next/image'

import {logEvent} from '@lib/gtm'

type ServicesProps = {
  animationProps: (delay?: number) => {
    initial: {
      opacity: number
      y: number
    }
    animate: {
      opacity: number
      y: number
    }
    transition: {
      duration: number
      ease: number[]
      delay: number
    }
  }
  scrollTo: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export const Why = ({animationProps, scrollTo}: ServicesProps) => {
  const controls = useAnimation()
  const LIST = [
    '<p>จัดการ Dataset ได้ <strong>หลากหลาย</strong></p>',
    '<p>มีบริการครบวงจร <strong>ตั้งแต่การออกแบบ <br/>การวางแผน จนจบงาน</strong></p>',
    '<p>ปรับเพิ่ม<strong>จำนวนทีมงานตามความต้องการ</strong> ได้ทันที</p>',
    '<p>การันตีความปลอดภัยของข้อมูลด้วย <strong>ISO27701 และ ISO 27001</strong></p>',
    '<p>ดำเนินการโดยทีมผู้เชี่ยวชาญด้าน <br/><strong>Machine Learning</strong></p>',
  ]

  useEffect(() => {
    const element = document.querySelector('.DataLabeling__why')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])

  return (
    <motion.div
      className='DataLabeling__why'
      initial={{opacity: 0, y: 20}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='DataLabeling__why__container'>
        <div className='DataLabeling__why__container__img'>
          <div className='DataLabeling__why__container__img__bg1' />
          <div className='DataLabeling__why__container__img__bg2' />
          <motion.div {...animationProps(0.2)}>
            <Image
              alt='Data Labeling'
              src='/images/services/data-labeling/why.png'
              width='452px'
              height='662px'
              priority
            />
          </motion.div>
        </div>
        <div className='DataLabeling__why__container__content'>
          <h2>
            ทำไมบริษัทชั้นนำถึง <br />
            เลือก <span>Data Wow?</span>
          </h2>

          <ul className='DataLabeling__why__container__content__list'>
            {LIST.map((item, idx) => (
              <li
                key={idx}
                className='DataLabeling__why__container__content__list__item'
              >
                <div className='icon'>
                  <Image
                    alt='Data Labeling'
                    src='/images/services/data-labeling/check.svg'
                    width='22px'
                    height='22px'
                  />
                </div>
                <div
                  key={idx}
                  className='item'
                  dangerouslySetInnerHTML={{__html: item}}
                />
              </li>
            ))}
          </ul>
          <div className='DataLabeling__why__container__content__iso'>
            <Image
              className='iso-logo'
              alt='Data Labeling'
              src='/images/iso/pm722313.png'
              width='133px'
              height='80px'
            />
            <Image
              className='iso-logo'
              alt='Data Labeling'
              src='/images/iso/pm744494.png'
              width='133px'
              height='80px'
            />
          </div>
          <motion.a
            {...animationProps(0.2)}
            href='#contact'
            onClick={(e) => {
              scrollTo(e)
              logEvent({
                ga: {
                  category: 'Data Labeling',
                  action: 'Action: Click CTA',
                },
              })
            }}
            className='DataLabeling__why__container__content__button'
          >
            ปรึกษาผู้เชี่ยวชาญฟรี
          </motion.a>
        </div>
      </div>
    </motion.div>
  )
}
